import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';

export const ForbiddenGridContainer = styled(Grid)`
    width: 100%;
`;

export const MyCaseOrderManagementGrid = styled(Grid)`
    width: 100%;
`;

export const OrderManagementHeading = styled.div`
    color: grey;
    font-size: 40px;
    font-family: AvenirNextWorld Demi;
    margin-bottom: 20px;
`;

export const OrderManagementSpan = styled.span`
    padding-left: 10px;
`;

export const ForbiddenGrid = styled(Grid)`
    width: 100%;
    font-family: serif;
    font-weight: bold;
    font-size: 20px;
`;

export const ErrorMessageGrid = styled(Grid)`
    width: 100%;
    font-family: serif;
    line-height: 1.5;
`;

export const ErrorMsgDiv = styled.div`
    display: flex;
    margin-top: 20px;
    flex-direction: column;
`;

export const ErrorContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin: 0;
    background: #140f4b 0% 0% no-repeat padding-box;
    opacity: 1;
    height: 110vh;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;

    ${media.mobileDevice`
        flex-direction: column;
        justify-content:center;
        align-items:center;
        padding: 0;
        margin-top: ${({ marginTop }) => (marginTop ? marginTop : '-8rem')};
        `}
`;

export const Reason = styled.div`
    width: 398px;
    height: 45px;
    max-height: 68px;
    overflow: scroll;
    font-size: 16px;
    line-height: 24px;
    color: #ffad00;
    font-family: 'AvenirNextWorld Demi';
    opacity: 1;
    text-align: left;

    ${media.mobileDevice`
        width: 233px;
        height: 109px;
        max-height:109px;
        font-size: 15px;
    `}
    & a {
        color: #ffad00;
    }
`;